<template>
  <b-modal
    id="termPolicyModal"
    modal-class="client-details-modal"
    centered
    size="md"
    hide-footer
    no-close-on-backdrop
    hide-header-close
    @hidden="resetForm"
    @shown="getTermedDates"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <div class="view-clients-header">
        <b-button
          variant="close-btn"
          class="btn-container"
          @click="$bvModal.hide('termPolicyModal')"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>

    <b-container fluid>
      <div class="form-part">
        <div class="title-text text-center mb-3">
          <h5><strong>Terminate/Withdraw Policy</strong></h5>
        </div>
        <!-- <p>{{ statusOptions }}</p> -->
        <div class="plan-details mb-4">
          <p><strong>PolicyID:</strong> {{ member?.policy_id }}</p>
          <p>
            <strong>Name:</strong> {{ member?.first_name }}
            {{ member?.last_name }}
          </p>
          <p>
            <strong>Plan Details:</strong>
            {{ member?.plan_details[0]?.plan_title }}
          </p>
        </div>

        <form @submit.prevent="submitNote">
          <div class="mb-4">
            <label for="actionPerformed"
              >Choose Action to be performed
              <span class="text-danger">*</span></label
            >
            <b-form-select
              id="actionPerformed"
              v-model="actionPerformed"
              :options="actionOptions"
              class="memberSearch-field mt-2"
            >
              <template #first>
                <option value="" disabled selected>Select an action </option>
              </template>
            </b-form-select>
            <div
              v-if="$v.actionPerformed.$dirty && !$v.actionPerformed.required"
              class="text-danger"
            >
              Action is required.
            </div>
          </div>

          <div class="mb-4">
            <label for="effectiveDate"
              >Terminate/Withdraw Date <span class="text-danger">*</span></label
            >
            <b-form-select
              id="effectiveDate"
              v-model="form.tdate"
              class="memberSearch-field mt-2"
              :disabled="actionPerformed === 'withdraw'"
            >
              <template #first>
                <option value="" disabled selected
                  >Select an Terminate/Withdraw Date</option
                >
              </template>
              <option
                v-if="actionPerformed === 'withdraw'"
                :value="member?.effective_date"
                selected
                disabled
              >
                {{ member?.effective_date }}
              </option>
              <template v-else>
                <option
                  v-for="(option, index) in statusOptions"
                  :key="index"
                  :value="option"
                >
                  {{ option }}
                </option>
              </template>
            </b-form-select>
            <div
              v-if="$v.form.tdate.$dirty && !$v.form.tdate.required"
              class="text-danger"
            >
              Effective date is required.
            </div>
          </div>

          <div class="mb-4">
            <label for="action"
              >Action <span class="text-danger">*</span></label
            >
            <b-form-input
              id="action"
              :value="form.action"
              disabled
              class="memberSearch-field mt-2"
            />
            <div
              v-if="$v.form.action.$dirty && !$v.form.action.required"
              class="text-danger"
            >
              Action type is required.
            </div>
          </div>

          <div class="mb-4">
            <label for="reason"
              >Reason <span class="text-danger">*</span></label
            >
            <b-form-textarea
              id="reason"
              v-model="form.text"
              rows="3"
              class="memberSearch-field mt-2"
              placeholder="Enter your reason"
            />
            <div
              v-if="$v.form.text.$dirty && !$v.form.text.required"
              class="text-danger"
            >
              Reason is required.
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button
              type="submit"
              class="group-univ-btn text-center"
              :disabled="isSubmitting"
            >
              <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Submit
            </button>
          </div>
        </form>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import helper from "@/resource/Helper";
import Helper from "../../../resource/Helper";

export default {
  data() {
    return {
      form: {
        tdate: "",
        text: "",
        action: "",
      },
      isSubmitting: false,
      actionPerformed: "",
      statusOptions: [],
      actionOptions: [
        { value: "withdraw", text: "Withdraw" },
        { value: "terminate", text: "Terminate" },
      ],
    };
  },
  props: {
    member: Object,
  },
  watch: {
    actionPerformed(newValue) {
      if (newValue === "terminate") {
        this.$set(this.form, "action", "Termination for Other (TMO)");
        this.form.tdate = "";
      } else if (newValue === "withdraw") {
        this.$set(this.form, "action", "Withdrawn for Other (WNO)");
        this.form.tdate = this.member?.effective_date;
      }
    },
  },
  validations: {
    actionPerformed: { required },
    form: {
      tdate: { required },
      text: { required },
      action: { required },
    },
  },
  methods: {
    async submitNote() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isSubmitting = true;
      let loader = this.$loading.show();
      this.error = null;
      try {
        const url =
          this.actionPerformed === "terminate"
            ? `${process.env.VUE_APP_API_ADMIN_URL}/api/v1/terminate-policy`
            : `${process.env.VUE_APP_API_ADMIN_URL}/api/v1/withdraw-policy`;

        const payload = {
          policy_id: this.member?.policy_id,
          tdate: new Date(this.form.tdate).toISOString().split("T")[0],
          action: this.actionPerformed === "terminate" ? "tmo" : "wno",
          reason: this.form.text,
          aid: this.$store.getters.repId,
          sendEmail: 0,
        };

        const response = await axios.post(url, payload,{
          headers: {
            "X-Internal-Token": Helper.nueraProtectedApiToken(),
          }
        });
        if (response.status === 200) {
          helper.infoMessage(this, "success", response.data.message);
        }
      } catch (err) {
        console.error("Error submitting note:", err);
        helper.infoMessage(this, "success", err.data.message);
        this.error = "Failed to submit the request. Please try again later.";
      } finally {
        loader.hide();
        this.$bvModal.hide("termPolicyModal");
        this.$parent.$parent.getData();
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.form = {
        tdate: "",
        text: "",
        action: "",
      };
      this.actionPerformed = "";
      this.$v.$reset();
      this.$emit("closeModal");
    },
    async getTermedDates() {
  let loader = this.$loading.show();

  let [month, day, year] = this.member?.effective_date.split("/");
  let effectiveDate = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);

  try {
    const url = `${process.env.VUE_APP_API_URL}v2/get-termed-dates?effective_date=${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    const { data: { data } } = await axios.get(url);

    if (!Array.isArray(data)) {
      console.warn("API did not return an array!");
      this.statusOptions = [];
      return;
    }

    let currentDate = new Date();
    let oneMonthPrior = new Date();
    oneMonthPrior.setMonth(currentDate.getMonth() - 1);

   
    this.statusOptions = data
      .map(dateStr => {
        let dateObj = new Date(dateStr);
        return dateObj;
      })
      .filter(dateObj => dateObj > effectiveDate && dateObj >= oneMonthPrior)
      .map(dateObj => dateObj.toISOString().split("T")[0]);
  } catch (err) {
    console.error("Error fetching termed dates:", err);
  } finally {
    loader.hide();
  }
},

  },
};
</script>

<style>
.form-part label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.client-details-modal .modal-content .modal-body {
  max-height: 700px !important;
}
</style>
